import { ref } from '@vue/runtime-dom'

// 业务类型
export const businessTypeEnum = {
  1: '备案',
  2: '转移',
  3: '查看违章'
}

export const getTableConfig = () => {
  const common = {
    isSelection: false,
    loading: false,
    stripe: true,
    height: null,
    size: 'small',
    isIndex: true,
    indexLabel: '序号',
    data: []
  }

  const pagination = {
    isShow: true,
    total: 0,
    pageSize: 20,
    currentPage: 1,
    pageSizes: [10, 20, 40, 80, 100]
  }

  const column = [
    {
      key: 'carNo',
      label: '车牌号',
      width: '110'
    },
    {
      key: 'businessTypeMsg',
      label: '业务类型',
      width: '100'
    },
    {
      key: 'expireTime',
      label: '本次操作后有效期',
      width: '110',
      formatter: (row: any) => (row.expireTime || '').slice(0, 10) || '-'
    },
    {
      key: 'externalContractNo',
      label: '关联合同编号',
      width: '170'
    },
    {
      key: 'externalContractExpireTime',
      label: '合同到期时间',
      width: '110',
      formatter: (row: any) => (row.externalContractExpireTime || '').slice(0, 10) || '-'
    },
    {
      key: 'usageDays',
      label: '实际使用天数',
      width: '110'
    },
    {
      key: 'overQuota',
      label: '超额',
      width: '80',
      align: 'center',
      formatter: (row: any) => (row.overQuota === 1 ? '超额' : '-')
    },
    {
      key: 'unitPrice',
      label: '单价（元/辆/天）',
      width: '130'
    },
    {
      key: 'terminateTime',
      label: '中止时间',
      width: '110',
      formatter: (row: any) => (row.terminateTime || '').slice(0, 10) || '-'
    },
    {
      key: 'operator',
      label: '操作人',
      width: '100'
    },
    {
      key: 'createTime',
      label: '操作时间',
      width: '150'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}

// 搜索配置
export const inputList = (remoteData1: any) => [
  {
    type: 'select',
    label: '所属公司',
    key: 'companyUuid',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200,
    maxlength: 50,
    options: remoteData1.options,
    isLoading: remoteData1.isLoading,
    isRemote: true,
    isMultiple: false,
    isFilterable: true,
    isCollapseTags: false,
    remoteMethod: remoteData1.remoteMethod
  },
  {
    type: 'input',
    label: '车牌号',
    key: 'carNo',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200
  },
  {
    type: 'select',
    label: '业务类型',
    key: 'businessType',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 200,
    options: [
      { label: '备案', value: 1 },
      { label: '转移', value: 2 },
      { label: '查看违章', value: 3 }
    ]
  }
]

// 页面搜索和基础变量
export const getIndexConfig = () => {
  const page = {
    queryForm: ref<any>({}),
    visible: false,
    rowData: null,
    determine: false,
    title: ''
  }
  return {
    ...page
  }
}
